import { NgModule } from '@angular/core';
import { BrowserModule, Title, Meta } from '@angular/platform-browser';
import { RouterModule, Routes } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';

import { AngularFireModule } from 'angularfire2';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFireDatabase } from 'angularfire2/database';
import 'firebase/storage';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';

import { AppRoutingModule } from './app.routing.module';
import { AppComponent } from './app.component';
import { HomePage } from './pages/home/home';
import { LocationPage } from './pages/location/location';
import { RestaurantPage } from './pages/restaurant/restaurant';
import { ItemPage } from './pages/item/item';
import { ForPage } from './pages/for/for';

import { SwiperComponent } from './components/swiper/swiper';

import { RestaurantProvider } from './providers/restaurant';
import { MenuProvider } from './providers/menu';
import { ItemProvider } from './providers/item';
import { SetupProvider } from './providers/setup';

import { KeysPipe } from './pipes/keys';

export const firebaseConfig = {
    apiKey: "AIzaSyB147yu7yTLAtEtkAcmd3l1UkIcAbI7xs4",
    authDomain: "menu-c4c57.firebaseapp.com",
    databaseURL: "https://menu-c4c57.firebaseio.com",
    projectId: "menu-c4c57",
    storageBucket: "menu-c4c57.appspot.com",
    messagingSenderId: "568670556997"
};

@NgModule({
  declarations: [
    AppComponent,
    HomePage, 
    LocationPage,
    ForPage,
    RestaurantPage, 
    ItemPage,
    SwiperComponent,
    KeysPipe
  ],
  imports: [
  	NgbModule.forRoot(),
    BrowserModule,
    AppRoutingModule,
    AngularFireModule.initializeApp(firebaseConfig),
    ReactiveFormsModule, 
		HttpModule,
    FormsModule
  ],
  providers: [
		AngularFireAuth,
		AngularFireDatabase,
		Title,
		Meta,
  	
  	RestaurantProvider,
  	MenuProvider,
  	ItemProvider,
  	SetupProvider
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/nikolay/Documents/GitHub/menu-web/src/app/app.module.ts